import '@mui/styles';
import { SnackbarProvider } from 'notistack';
import { ReactNode } from 'react';
import useStyles from '../../style';

const StyledSnackbarProvider = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return (
    <>
      {/* @ts-ignore */}
      <SnackbarProvider
        maxSnack={3}
        classes={{
          variantSuccess: classes.snackBarSuccess,
          variantError: classes.snackBarError,
        }}
      >
        {children}
      </SnackbarProvider>
    </>
  );
};

export default StyledSnackbarProvider;
